/** @see $bog_builderui_tokens */
namespace $ {
	$mol_style_define( $bog_builderui_chart, {
		font: {
			family: $bog_builderui_tokens.font_body,
		},
		color: $bog_builderui_tokens.text,
	} )
}
